/* eslint-disable */

/**
 * 该文件为脚本自动生成文件，请勿随意修改。如需修改请联系 PMC
 * */

import { TdTabBarProps } from './type';
const props: TdTabBarProps = {
  /** 是否显示外边框 */
  bordered: {
    type: Boolean,
    value: true,
  },
  /** 是否固定在底部 */
  fixed: {
    type: Boolean,
    value: true,
  },
  /** 固定在底部时是否开启占位 */
  placeholder: {
    type: Boolean,
    value: false,
  },
  /** 是否开启底部安全区适配 */
  safeAreaInsetBottom: {
    type: Boolean,
    value: true,
  },
  /** 标签栏的形状 */
  shape: {
    type: String,
    value: 'normal',
  },
  /** 是否需要分割线 */
  split: {
    type: Boolean,
    value: true,
  },
  /** 选项风格 */
  theme: {
    type: String,
    value: 'normal',
  },
  /** 当前选中标签的索引 */
  value: {
    type: null,
    value: null,
  },
  /** 当前选中标签的索引，非受控属性 */
  defaultValue: {
    type: null,
  },
  /** 标签栏层级 */
  zIndex: {
    type: Number,
    value: 1,
  },
};

export default props;
